import { useRecoilState } from 'recoil';
import { ChannelInfoViewState } from '../recoil/channels/channel-info-view.state';

export function useView(value: string): [string, Function] {
  const [option, setOption] = useRecoilState(ChannelInfoViewState);

  const update = (val: string) => {
    setOption((prev) => ({ ...prev, current: val }));
  };

  return [option.current, update];
}
